import React from 'react';
import { AppGridLayout, AppTable, AppTableSearch, AppSearchItem, AppButton, AppRow, AppGridBar, AppFilter } from 'qcc';
import { AppAction } from 'qcc';
import api, { AppUser, AppOrgan } from 'api';
import { default as EditForm } from './UserEdit';
import { default as UserModifyPasswordEdit } from './UserModifyPasswordEdit';
import { MdmProjectSearchor } from '../../public'

export default class extends React.Component<{ organId?: number }> {

  state = {}


  add = async () => {
    if (this.props.organId && this.props.organId !== 0) {
      let organ = await api.apporgan.getOne({ id: this.props.organId });
      let { id, parentId, organType } = organ;
      let companyId = organType === 2 ? parentId : id;
      let formData = { name: '', gender: '1', organId: id, companyId, adUser: false } as AppUser
      let organList = await api.apporgan.getList()
      AppAction.openDialog(<EditForm mode={1} formData={formData} afterSave={this.afterSave} organList={organList} />, { title: '新增用户', width: 600, height: 360 })
    }
  }

  edit = async (user?: any) => {
    let formData = await api.appuser.getOne({ userId: user.id });
    let organList = await api.apporgan.getList()
    AppAction.openDialog(<EditForm mode={2} formData={formData} afterSave={this.afterSave} organList={organList} />, { title: '编辑用户', width: 600, height: 360 })
  }

  selectProject = async (user?: any) => {
    let selectedProject = await api.mdmproject.getUserAuthorizeProject({ id: user.id })
    let selectedOrgan = await api.apporgan.getUserAuthorizeOrgan({ id: user.id })
    let editPage = <MdmProjectSearchor id={user.id} selectedProject={selectedProject} selectedOrgan={selectedOrgan} mode={2} />
    let title = `项目授权（${user.name}）`
    AppAction.openDrawer(editPage, { title });
  }

  modifyPassword = async (user?: any) => {
    let formData = await api.appuser.getOne({ userId: user.id });
    AppAction.openDialog(<UserModifyPasswordEdit mode={2} formData={formData} />, { title: '修改密码', width: 500, height: 300 })
  }

  delete = async (data?: AppUser) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.appuser.delete(data);
      AppAction.successMsg('删除成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  render() {
    let { organId } = this.props
    return (
      <AppGridLayout ref={this.refGrid} style={{ padding: 0 }}>
        <AppGridLayout.SearchArea>
          <AppTableSearch>
            <AppTableSearch.Common>
              <AppSearchItem.SearchInput placeholder='请录入姓名' keyName='common' field='name' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppButton label='新增' actionCode='00010201' type='primary' action={this.add} />
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging
            sqlId='sql.user.grid'
            orderBy='a.id'
            onBeforeApi={() => { return organId !== undefined && organId !== 0 }}
            queryDataList={getOrganFilter(organId)}
          >
            <AppTable.ColIndex />
            <AppTable.Col title='名称' field='name' width={100} />
            <AppTable.Col title='账号' field='account' width={120} />
            <AppTable.Col title='组织' field='organ' width={100} />
            <AppTable.Col title='域用户' field='ad_user_chn' align='center' width={80} />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                <AppButton type='link' label='项目授权' actionCode='00010206' action={() => this.selectProject(data)} />
                <AppButton type='link' label='修改密码' actionCode='00010204' action={() => this.modifyPassword(data)} />
                <AppButton type='link' label='编辑' actionCode='00010203' action={() => this.edit(data)} />
                <AppButton type='link' label='删除' actionCode='00010205' action={() => this.delete(data)} />
              </AppRow>)
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>)
  }
}

const getOrganFilter = (organId: number) => {
  return [{
    keyName: 'organId',
    lable: '',
    field: 'organ_id',
    min: '',
    max: '',
    opr: 'organ_collection',
    value: `${organId}`,
    list: [],
    searchItemType: 'projectFilter'
  }] as AppFilter[]
}


// WEBPACK FOOTER //
// ./src/page/application/user/UserGrid.tsx